import { createSlice } from "@reduxjs/toolkit";

const otherItemsSlice = createSlice({
    name:'otheritem',
    initialState:{
        otheritem:[]
    },
    reducers: {
        addOtherItemsStore : (state,action) => {
            state.otheritem = [...state.otheritem,action.payload]
        },
        // removeOccupation(){
        //     return state.occupation.filter((item)=> item.id != action.payload);
        // }
    }
});

export const { addOtherItemsStore } = otherItemsSlice.actions;
export default otherItemsSlice.reducer;